export default __webpack_public_path__ + "static/media/TV01.90a01767.png";